import { styled } from "@mui/material/styles";

/**
 * ResponsiveMain
 *
 * A responsive styled <main> element that adjusts its width and left margin based on drawer state and device type.
 * - On desktop, it shifts right and resizes to accommodate the drawer width.
 * - On mobile, it uses full width with no margin.
 *
 * @param {boolean} isMobile - Whether the layout is rendered on a mobile device
 * @param {number} drawerWidth - The width of the navigation drawer (in px)
 *
 * @example
 * <ResponsiveMain isMobile={false} drawerWidth={240}>...</ResponsiveMain>
 */
export const ResponsiveMain = styled("main")<{
    isMobile: boolean;
    drawerWidth: number;
}>(({ theme, isMobile, drawerWidth }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.short,
    }),
    // Adjusts margin based on drawer width
    ...(!isMobile && {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
    }),
}));
